<template>
	<div
		v-bind="getAttrs($attrs)"
		class="WurldSelect"
	>
		<label
			v-bind="getAttrs($attrs, 'label')"
			v-if="label && !labelAfter"
			v-html="label"
			:for="guid"
		></label>
		<select
			@input="$emit('input', $event.target.value)"
			v-bind="getAttrs($attrs, 'select')"
			:disabled="disabled || readonly"
			:id="label || uid ? guid : null"
			:name="!readonly && name ? name : null"
			:required="required"
		>
			<option
				v-bind="getAttrs($attrs, 'option')"
				v-if="placeholder && (!value || !required)"
				value=""
				:selected="!value"
			>{{ placeholder }}</option>
			<template	v-for="(option, key) in options">
				<optgroup
					v-bind="getAttrs($attrs, 'optgroup')"
					v-if="isArray(option.value)"
					:key="`og${guid}${key}`"
					:label="option.label"
				>
					<option
						v-bind="getAttrs($attrs, 'option')"
						v-for="(ogOption, key) in option.value"
						:key="`ogo${guid}${key}`"
						:value="ogOption.value"
						:selected="ogOption.value === value"
					>{{ ogOption.label }}</option>
				</optgroup>
				<option
					v-bind="getAttrs($attrs, 'option')"
					v-else
					:key="`o${guid}${key}`"
					:value="option.value"
					:selected="option.value === value"
				>{{ option.label }}</option>
			</template>
		</select>
		<input
			v-if="readonly"
			type="hidden"
			:name="name"
			:value="value"
		>
		<label
			v-bind="getAttrs($attrs, 'label')"
			v-if="label && labelAfter"
			v-html="label"
			:for="guid"
		></label>
	</div>
</template>

<script>
export default {
	name: 'WurldSelect',
	inheritAttrs: false,
	props: {
		disabled: {
			default: false,
			type: Boolean
		},
		label: {
			default: null,
			type: String
		},
		labelAfter: {
			default: false,
			type: Boolean
		},
		name: {
			default: null,
			type: String
		},
		options: {
			default: null,
			type: Array
		},
		placeholder: {
			default: null,
			type: String
		},
		readonly: {
			default: false,
			type: Boolean
		},
		required: {
			default: false,
			type: Boolean
		},
		uid: {
			default: null,
			type: String
		},
		value: {
			default: null,
			type: String
		}
	},
	data () {
		return {
			guid: ''
		};
	},
	mounted () {
		this.guid = this.uid ? this.uid : this.generateUID('WurldSelect');
	}
};
</script>
